import React, { useEffect, useState } from "react"
import Link from "next/link"
import { useRouter } from "next/router"
import { useDispatch, useSelector } from "react-redux"
import { getBookings, logoutUser } from "../pages/api/api"
import { FaBars, FaTimes } from "react-icons/fa"
import Image from "next/image"
import Config from "./SidebarConfig"
import * as faIcons from "react-icons/fa"

const Navbar = () => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [bookingCount, setBookingCount] = useState(null)
// Removed unused sidebarConfig state
  const router = useRouter()
  const user = useSelector((state) => state.auth.user)
  const isClient = !!user.client_id && ["Fleet Owner", "Site Staff", "Charger Owner"].includes(user.role)
  const isCustomer = !!user.customer_id && ["Fleet Owner", "Driver"].includes(user.role)

  useEffect(() => {
    if (isOpen) {
      setIsOpen(!isOpen)
    }
  }, [router.asPath])

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        if (!bookingCount && isClient) {
          const bookings = await getBookings({ isClient: true })
          const pendingBookingsCount = bookings?.filter((b) => b.booking_approval === null).length

          setBookingCount(pendingBookingsCount)
        }
      } catch (error) {
        setBookingCount(0)
      }
    }
    fetchBookings()
  }, [bookingCount, isClient])


// Removed the useEffect that computes confName and updates sidebarConfig as it is redundant.

  const toggleMenu = () => setIsOpen(!isOpen)
  const handleLogout = () => {
    logoutUser(dispatch)
    if (!window.location.pathname.includes("/login")) {
      window.location.href = "/login?final=" + window.location.pathname
    }
  }

  const menuItems = [
    {
      label: "Find a Charger",
      href: "/find-charger",
      iconSrc: "/images/smartphone-charging.svg",
      isCustomer: true,
      key: "find-charger",
    },
    {
      label: "Charging Sessions",
      href: "/sessions/active-upcoming-sessions",
      iconSrc: "/images/calendar-days.svg",
      isCustomer: true,
      key: "sessions",
    },
    { divider: true, isCustomer: true, key: "divider" },
    {
      label: "Chargers & Tariffs",
      href: "/chargers/list",
      iconSrc: "/images/clock.svg",
      isClient: true,
      key: "chargers",
    },
    {
      label: "Bookings",
      href: "/bookings/active-upcoming-bookings",
      iconSrc: "/images/calendar-days.svg",
      notification: bookingCount,
      isClient: true,
      key: "bookings",
    },
    { label: "Customers", href: "/customers", iconSrc: "/images/line-chart.svg", isClient: true, key: "customers" },
    { label: "Settings", href: "/settings/global", iconSrc: "/images/settings-2.svg", isClient: true, key: "settings" },
    { divider: true, isClient: true, key: "divider" },
    {
      label: "Organisation",
      href: "/organisation/details",
      iconSrc: "/images/building-2.svg",
      isCustomer: true,
      key: "organisation",
    },
    { divider: true, isClient: true, key: "divider" },
    { label: "Logout", iconSrc: "/images/logout.svg", onClick: handleLogout, href: "#", key: "logout" },
  ]

  return user?.email || user?.customer_email ? (
    <nav className="bg-white shadow-md relative z-[150]">
      <div className="max-w-screen py-2 px-2 lg:px-4">
        <div className="flex items-center justify-between py-2">
          <Link href={"/"} className="flex-shrink-0 mr-auto">
            <Image className="max-h-6" src="/images/newLogo.svg" alt="FPS Logo" width={48} height={48} />
          </Link>
          <div className="hidden md:flex md:items-center md:space-x-2">
            {menuItems.map((item, index) =>
              (item && item.isClient && !isClient) || (item.isCustomer && !isCustomer) ? null : item.divider ? (
                <div key={index} className="h-5 w-px bg-gray-300" />
              ) : (
                <Link
                  key={index}
                  href={item.href}
                  className={`p-2 flex flex-shrink-1 items-center gap-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900 rounded-md text-sm font-medium ${
                    router.route.split("/").includes(item.key) && "bg-gray-100"
                  }`}
                  onClick={item.onClick}
                >
                  {item.icon && <item.icon className="h-5 w-5" />}
                  {item.iconSrc && <Image src={item.iconSrc} width={16} height={16} alt="item-icon" />}
                  <span className="flex max-w-fit min-h-full">{item.label}</span>
                  {item.notification > 0 && (
                    <span className="p-2 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      {item.notification}
                    </span>
                  )}
                </Link>
              )
            )}
          </div>
          <div className="-mr-2 flex items-center md:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
              onClick={toggleMenu}
            >
              <span className="sr-only">Open main menu</span>
              {isOpen ? (
                <FaTimes className="block h-6 w-6" aria-hidden="true" />
              ) : (
                <FaBars className="block h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu, show/hide based on menu state */}
      <div className={`md:hidden block ${isOpen ? "bg-white z-50" : "hidden"}`} id="mobile-menu">
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
          {menuItems.map(
            (item, index) => {
              if (!item || item.divider) return null;

              // Get the config for this menu item's section if it exists
              const itemSidebarConfig = Config[item.key];
              return (
                <div key={index}>
                  <Link
                    href={item.href}
                    className="text-gray-700 hover:bg-gray-100 hover:text-gray-900 px-3 py-2 rounded-md text-base font-medium flex items-center"
                    onClick={() => {
                      if (item.onClick) item.onClick()
                      setIsOpen(false)
                    }}
                  >
                    {item.icon && <item.icon className="h-5 w-5 mr-2" />}
                    {item.iconSrc && <Image src={item.iconSrc} alt="item-icon" width={16} height={16} className="mr-2" />}
                    {item.label}
                    {item.notification > 0 && (
                      <span className="inline-flex items-center ml-s px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 ml-2">
                        {item.notification}
                      </span>
                    )}
                  </Link>

                  {/* Always show sidebar items if they exist for this section */}
                  {itemSidebarConfig && (
                    <div className="ml-6 border-l border-gray-200 pl-3 mt-2 space-y-1">
                      {itemSidebarConfig.routes.map((subItem, subIndex) => (
                        <Link
                          key={subIndex}
                          href={subItem.route}
                          className={`text-gray-600 hover:bg-gray-50 hover:text-gray-900 block px-3 py-2 rounded-md text-sm font-medium flex items-center ${
                            router.pathname === subItem.route ? "bg-gray-100" : ""
                          }`}
                          onClick={() => setIsOpen(false)}
                        >
                          {subItem.icon && (
                            <span className="mr-2">
                              {React.createElement(faIcons[subItem.icon] || faIcons.FaQuestionCircle)}
                            </span>
                          )}
                          {subItem.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
          )}
        </div>
      </div>
    </nav>
  ) : null
}

export default Navbar
